import * as Yup from 'yup';

export const apiKeyCreateSchema = Yup.object().shape({
  secret_name: Yup.string().required('API Key name is required'),
});

export type ApiKeyCreateFormValues = Yup.InferType<typeof apiKeyCreateSchema>;
